// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.99976 10.1V22H4.84976L4.84943 10.1H1.99976Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.0341 8.2998H19.3261C21.1756 8.29996 22.7813 9.85301 22.4609 11.7695L21.1728 19.4688C20.9194 20.9843 19.5383 22 18.038 22H6.83578V10.096L10.5273 1.27832L12.3212 1.82812C13.8944 2.31061 15.034 3.69898 15.0341 5.3457V8.2998Z"}}]};

const ThumbUp2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-2-filled',
    ref,
    icon: element,
  },
));

ThumbUp2FilledIcon.displayName = 'ThumbUp2FilledIcon';

export default ThumbUp2FilledIcon;
